import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../config/api"; // Adjust path if needed
import { IMG_URL } from "../config/api"; // Adjust path if needed
import Swal from "sweetalert2";

const EditReport = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await fetch(`${BASE_URL}reports/${id}`);
        const data = await response.json();

        if (data.status === 1) {
          setName(data.data.name);
          setDescription(data.data.description);

          try {
            const parsedImages =
              typeof data.data.images === "string"
                ? JSON.parse(data.data.images)
                : data.data.images;

            setExistingImages(Array.isArray(parsedImages) ? parsedImages : []);
          } catch (err) {
            console.error("Error parsing image data:", err);
            setExistingImages([]);
          }
        } else {
          setError(data.message || "Failed to fetch report details");
        }
      } catch (err) {
        console.error("Error fetching report:", err);
        setError("An error occurred while fetching report details");
      }
    };

    fetchReport();
  }, [id]);

  const handleImageChange = (e) => {
    setImages([...e.target.files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name || !description) {
      setError("Name and Description are required");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    images.forEach((file) => formData.append("images", file)); // `images` is plural here, adjust if backend expects different

    try {
      const response = await fetch(`${BASE_URL}reports/${id}`, {
        method: "PUT",
        body: formData,
      });

      const contentType = response.headers.get("Content-Type");
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        if (data.status === 1) {
          Swal.fire({
            icon: "success",
            title: "Report updated successfully!",
          });
          navigate("/ReportsList");
        } else {
          setError(data.message || "Error updating report");
        }
      } else {
        const errorText = await response.text();
        console.error("Unexpected response:", errorText);
        setError("Unexpected error occurred");
      }
    } catch (err) {
      console.error("Error updating report:", err);
      setError(err.message || "Error updating report");
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Edit Report</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header"></div>
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Report Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter report name"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Enter report description"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Current Images</label>
                    <div className="d-flex flex-wrap gap-2">
                      {existingImages.length > 0 ? (
                        existingImages.map((img, idx) => (
                          <img
                            key={idx}
                            src={`${IMG_URL}${img}`}
                            alt={`Existing ${idx}`}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        ))
                      ) : (
                        <p>No existing images</p>
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="images" className="form-label">
                      Upload New Images
                    </label>
                    <input
                      type="file"
                      id="images"
                      className="form-control"
                      multiple
                      onChange={handleImageChange}
                    />
                  </div>

                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      Update Report
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditReport;
